import { Check } from "lucide-react";
import { cn } from "@/lib/utils";
import { autofix, cssVars, derive } from "@/lib/theme/colors";

export function PresetThumb({ tokens }) {
  const vars = cssVars(derive(autofix(tokens)));
  return (
    <div style={vars} className="h-20 rounded-md overflow-hidden border border-le-border flex bg-le-page" aria-hidden>
      <div className="w-1/4 bg-le-sidebar p-1.5 space-y-1">
        <div className="h-1.5 rounded bg-le-selected" />
        <div className="h-1.5 rounded bg-le-border" />
        <div className="h-1.5 rounded bg-le-border" />
      </div>
      <div className="flex-1 flex flex-col">
        <div className="h-3 bg-le-surface border-b border-le-border" />
        <div className="flex-1 p-1.5 space-y-1.5">
          <div className="bg-le-surface rounded border border-le-border p-1 space-y-1">
            <div className="h-1.5 w-2/3 rounded bg-le-text" />
            <div className="h-1 w-1/2 rounded bg-le-text-2" />
          </div>
          <div className="flex gap-1 items-center">
            <div className="h-2.5 w-8 rounded bg-le-primary" />
            <div className="h-2.5 w-6 rounded border border-le-input-border bg-le-surface" />
            <div className="h-2 w-2 rounded-full bg-le-accent" />
          </div>
        </div>
      </div>
    </div>
  );
}

export default function PresetCard({ preset, selected, onSelect, disabled, testId }) {
  return (
    <button
      type="button"
      onClick={() => onSelect(preset.id)}
      disabled={disabled}
      aria-pressed={selected}
      data-testid={testId || `preset-${preset.id}`}
      className={cn(
        "group text-left rounded-lg border bg-le-surface p-2.5 transition-[border-color,box-shadow] duration-150",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-le-focus focus-visible:ring-offset-2",
        "disabled:opacity-50 disabled:cursor-not-allowed",
        selected ? "border-le-primary ring-1 ring-le-primary shadow-sm" : "border-le-border hover:border-le-border-strong hover:shadow-sm"
      )}
    >
      <div className="relative">
        <PresetThumb tokens={preset.tokens} />
        {selected && (
          <span className="absolute right-1.5 top-1.5 inline-flex items-center gap-1 rounded-full bg-le-primary px-1.5 py-0.5 text-2xs font-semibold text-white shadow-sm">
            <Check className="h-3 w-3" aria-hidden /> Selected
          </span>
        )}
      </div>
      <div className="mt-2 min-w-0">
        <div className="text-sm font-semibold text-le-text">{preset.name}</div>
        <div className="mt-0.5 text-xs text-le-t-2 leading-snug">{preset.description}</div>
      </div>
    </button>
  );
}
